export default __webpack_public_path__ + "static/media/photo-1587351021355-a479a299d2f9.7efa5b54.jpg";